import { ListNode } from "./list-node";

export class TreeAncestor {
    private list?: ListNode;

    public constructor(
        private readonly nodes: any[],
        private readonly id: (node: any) => any,
        private readonly condition: (node: any) => boolean,
        private readonly parent: (node: any) => any,
    ) {
        if (nodes?.length) {
            this.setupList(nodes[0]);
            this.nodes = nodes.slice(1);
        }
    }

    public get leastCommon(): any {
        if (this.nodes?.length) {
            for (let node of this.nodes) {
                if (this.list) {
                    this.checkCommon(node);
                }
            }
        }

        return this.list?.node;
    }

    private setupList(node: any): void {
        if (node) {
            this.list = new ListNode(node);
            let current = this.list;
            while ((node = this.parent(node)) && this.condition(node)) {
                current = current.next = new ListNode(node);
            }
        }
    }

    private createSet(node: any): Set<any> | undefined {
        if (node) {
            let set = new Set<any>();
            do {
                set.add(this.id(node));
            } while ((node = this.parent(node)) && this.condition(node));

            return set;
        }
    }

    private checkCommon(node: any): void {
        if (node) {
            const set = this.createSet(node);
            if (set) {
                while (this.list && !set.has(this.id(this.list.node))) {
                    this.list = this.list.next;
                }
            }
        }
    }
}
